import React, { Component } from "react";
import { Helmet } from "_c/Helmet";
import { generateUrl } from "@/utils/cloudinary";
import { LinkGenerator } from "@/utils/LinkGenerator";
import moment from "moment";
import qs from "query-string";
import { SITE_URL } from "@/misc/constants";

const ns = "master_profile:seo";
const MasterPageSEO = ({ meta, avatar, masterId, currency, t }) => {
  if (!meta) {
    return (
      <Helmet
        meta={[
          {
            name: "robots",
            content: "noindex",
          },
        ]}
      ></Helmet>
    );
  }
  // TODO:: render schema for bots only
  const pageLink = SITE_URL + LinkGenerator.masterProfile(meta.masterId);
  const canonical = qs.stringifyUrl({
    url: `${SITE_URL}/master`,
    query: {
      id: masterId,
    },
  });
  const avatarLink = avatar
    ? generateUrl(avatar)
    : `${SITE_URL}/mockups/avatar_big.png`;
  return (
    <>
      <Helmet
        link={[{ rel: "canonical", href: canonical }]}
        title={t(`${ns}.title`, {
          name: meta.name,
          currency,
          specs: meta.specs || "",
          city: meta.address || "",
          num: meta.pricingStartsFrom,
        })}
        meta={[
          {
            property: "og:image",
            content: avatarLink,
          },
          {
            name: "description",
            content: t(`${ns}.desc`, {
              currency,
              city: meta.address || "",
              name: meta.name,
              specs: meta.specs || "",
              num: meta.pricingStartsFrom,
            }),
          },
        ]}
      />
      <BotsOnly
        pageLink={pageLink}
        avatarLink={avatarLink}
        t={t}
        meta={meta}
        avatar={avatar}
      />
    </>
  );
};
class BotsOnly extends Component {
  shouldComponentUpdate() {
    return false;
  }
  render() {
    const { meta, t, pageLink, avatarLink } = this.props;
    return (
      <Helmet>
        {meta.services.map((service) => (
          <script key={service._id} type="application/ld+json">{`
{
  "@context": "https://schema.org/", 
  "@type": "Product", 
  "name": "${service.title}",
  "description": "${service.desc}",
  "brand": "Simpo",
  "offers": {
    "@type": "Offer",
    "url": "${pageLink}",
    "priceCurrency": "${service.price.currency}",
    "price": ${service.price.amount}
  }
}
`}</script>
        ))}
        <script type="application/ld+json">{`
{
  "@context": "https://schema.org/",
  "@type": "Person",
  "name": "${meta.name}",
  "url": "${pageLink}",
  "image": "${avatarLink}",
  "jobTitle": "${meta.specs}",
  "worksFor": {
    "@type": "Organization",
    "name": "${t("common:full_brand_name")}"
  }  
}
`}</script>
        <script type="application/ld+json">{`
{
	"@context": "https://schema.org/",
  "@type": "LocalBusiness",
  "name": "${meta.name}",
	${
    meta.coords
      ? `
	"geo": {
		"@type": "GeoCoordinates",
    "latitude": ${meta.coords[1]},
    "longitude": ${meta.coords[0]}
  },
	`
      : ""
  }
	"@id": "${meta.masterId}",
	"url": "${pageLink}",
	"image": "${avatarLink}",
	"address": {
		"@type": "PostalAddress",
		"streetAddress": "${meta.address}"
	},
	"aggregateRating": {
    "@type": "AggregateRating",
    "worstRating": 0,
    "bestRating": 10,
    "ratingValue": ${meta.rate},
    "ratingCount": ${meta.reviewsCount}
	},
	"review": [
		${meta.reviews.map(
      (review) => `
		{
			"@type": "Review",
			"author": {
				"@type": "Person",
				"name": "${[review.client.first_name, review.client.last_name]
          .filter(Boolean)
          .join(" ")}"
			},
			"reviewRating": {
				"@type": "Rating",
        "ratingValue": "${review.rate}",
        "worstRating": 0,
        "bestRating": 10
			},
			"datePublished": "${moment(review.created_at).format("YYYY-MM-DD")}",
			"reviewBody": "${review.text}"

		}
		`,
    )}
	],
	"openingHoursSpecification": ${JSON.stringify(meta.workingHours)}
}
`}</script>
      </Helmet>
    );
  }
}

export default MasterPageSEO;
